module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "imgdes2"
  }, [_c('img', {
    attrs: {
      "src": "Images/designtop.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "D1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexviii",
      "title": "xviii"
    }
  }), _vm._v("Prince Harry of Wales")]), _vm._v(" "), _c('p', {
    staticClass: "D2"
  }, [_vm._v("Born September 15, 1984")]), _vm._v(" "), _c('p', {
    staticClass: "D3"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexix",
      "title": "xix"
    }
  }), _vm._v("-and-")]), _vm._v(" "), _c('p', {
    staticClass: "D4"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexx",
      "title": "xx"
    }
  }), _vm._v("Meghan Markle")]), _vm._v(" "), _c('p', {
    staticClass: "D5"
  }, [_vm._v("Born August 4, 1981")]), _vm._v(" "), _c('div', {
    staticClass: "imgdes"
  }, [_c('img', {
    attrs: {
      "src": "Images/designbottom.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-092e8538","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Prince.vue
// module id = 75
// module chunks = 0